import sortBy from 'ramda/es/sortBy'
import path from 'ramda/es/path'

import i18next from 'app/i18n'

import api from './api'
import { schoolsSuccess, schoolsFailure } from './schools'

export const STUDENTS_REQUEST = 'STUDENTS_REQUEST'
export const STUDENTS_SUCCESS = 'STUDENTS_SUCCESS'
export const STUDENTS_FAILURE = 'STUDENTS_FAILURE'

export const studentsRequest = () => ({
  type: STUDENTS_REQUEST,
})

export const studentsSuccess = (data) => ({
  type: STUDENTS_SUCCESS,
  payload: data,
})

export const studentsFailure = (errString) => ({
  type: STUDENTS_FAILURE,
  payload: { err: errString },
})

const sortByName = sortBy(path(['name', 'first']))

/**
 * Преобразование данных из api в state для студентов (детей) и школ
 */
export const api2stateStudents = (apiData) => {
  const { students } = apiData.data
  const sortedStudents = sortByName(students)

  const data = {}
  const schools = { keys: [], data: {} }
  const keys = sortedStudents.map((item) => {
    data[item.id] = {
      id: item.id,
      accountId: item.account_id,
      name: item.name || {},
      firstName: item.name.first,
      middleName: item.name.middle,
      lastName: item.name.last,
      klass: item.klass ? item.klass.title : '',
      klassId: item.klass ? item.klass.id : null,
      school: item.school.title,
      schoolId: item.school.id,

      hasCafeteria: item.school.has_cafeteria,
      cafeteriaExternalService: item.school.cafeteria_external_service,
      cafeteriaExternalServiceType: item.school.cafeteria_external_service_type,

      hasPaymentOrders: item.school.has_payment_orders,

      shopUuid: item.school.shop_uuid,

      passagesExternalService: item.school.access_external_service,

      hasDnevnik: item.school.has_dnevnik,
      dnevnikExternalService: item.school.dnevnik_external_service,
      dnevnikExternalServiceType: item.school.dnevnik_external_service_type,
      dnevnikExternalServiceData: item.school.dnevnik_external_service_custom_data,
      dnevnikExternalServiceName:
        path(['school', 'dnevnik_external_service_custom_data', 'title'], item) || null,
      dnevnikExternalServiceLink:
        path(['school', 'dnevnik_external_service_custom_data', 'cabinet_link'], item) || null,
      dnevnikExternalServiceIcon:
        path(['school', 'dnevnik_external_service_custom_data', 'cabinet_icon'], item) || null,

      disableTransferParent2child: item.school.disable_transfer_parent2child,
      hasPresales: item.school.has_presales,
      hasPresalesTime: item.school.has_presales_time,
      photo: item.photo,
      sex: item.sex || 'androgynous', // TODO убрать
      gender: item.sex || 'androgynous',
      status: item.status,
      graduated: item.graduated || null,
      timezone: item.timezone,
      userUuid: item.user_uuid,
      orgType: item.school.type,
      leader: item.leader,
      personalAccountNumber: item.personal_account_number,
      appsBlocked: item.apps_blocked,
      externalSystemSync: item.school.synced || false,
      camps: item.camps || [],
      splitStudentDayLimit: item.school.split_student_day_limit || false,
    }
    // schools
    if (!schools.keys.includes(item.school.id)) {
      schools.keys.push(item.school.id)
      schools.data[item.school.id] = item.school.title
    }
    return item.id
  }) // end map
  return {
    students: { data, keys },
    schools,
  }
}

/**
 * Получение списка детей и школ
 */
export const fetchStudents = (silent, force) => async (dispatch, getState) => {
  const state = getState()
  if (state.students.expired > Date.now() && !force) return
  if (!silent) dispatch(studentsRequest())
  try {
    const response = await api('cabinet/students', 'get')
    const data = api2stateStudents(response)
    dispatch(studentsSuccess({ ...data.students, expired: Date.now() + 310000 }))
    // данные школ
    if (data.schools.keys.length) {
      dispatch(schoolsSuccess(data.schools))
    }
  } catch (error) {
    dispatch(studentsFailure(i18next.t('app:request_students_fail')))
    dispatch(schoolsFailure(i18next.t('app:request_schools_fail')))
  }
}

export const fetchStudentsForce = (silent) => fetchStudents(silent, true)
